/* This is a mst-gql generated file, don't modify it manually */
/* eslint-disable */
/* tslint:disable */

import { types } from "mobx-state-tree"
import { QueryBuilder } from "mst-gql"
import { ModelBase } from "./ModelBase"
import { RootStoreType } from "./index"


/**
 * PackageDtoBase
 * auto generated base class for the model PackageDtoModel.
 */
export const PackageDtoModelBase = ModelBase
  .named('PackageDto')
  .props({
    __typename: types.optional(types.literal("PackageDto"), "PackageDto"),
    uuid: types.identifier,
    barcode: types.union(types.undefined, types.string),
  })
  .views(self => ({
    get store() {
      return self.__getStore<RootStoreType>()
    }
  }))

export class PackageDtoModelSelector extends QueryBuilder {
  get uuid() { return this.__attr(`uuid`) }
  get barcode() { return this.__attr(`barcode`) }
}
export function selectFromPackageDto() {
  return new PackageDtoModelSelector()
}

export const packageDtoModelPrimitives = selectFromPackageDto().uuid.barcode
